import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { format, parseISO, fromUnixTime, formatDistanceToNow } from 'date-fns';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import { Link } from 'react-router-dom';

// Firebase
import { db } from '../../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, onSnapshot, orderBy, startAfter, limit } from 'firebase/firestore';

// Redux
import { connect } from 'react-redux';

// Actions
import { setAlert } from '../../actions/alertActions';
import { followGroup } from '../../actions/authActions';
import { createChat } from '../../actions/chatActions';

// Light Box
import { SRLWrapper } from "simple-react-lightbox";

// Components - material UI
import { Avatar, Button } from '@material-ui/core';
import DefaultAvatar from 'react-avatar';

// Icons - material UI
import PublicIcon from '@material-ui/icons/Public';
import { toggleProfileModal, toggleAuthModal, togglePrivacyModal } from '../../actions/navActions';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import LinkIcon from '@material-ui/icons/Link';
import CheckIcon from '@material-ui/icons/Check';
import DeleteIcon from '@material-ui/icons/Delete';
import Verification_Badge from '../common/Verification_Badge';
import MailIcon from '@material-ui/icons/Mail';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import EditIcon from '@material-ui/icons/Edit';
import LockIcon from '@material-ui/icons/Lock';
import VisibilityIcon from '@material-ui/icons/Visibility';
import SchoolIcon from '@material-ui/icons/School';

const GroupHeader = ({ 
    setAlert,
    followGroup,
    toggleAuthModal,
    togglePrivacyModal,
    group: { 
        group, 
        loading 
    }, 
    auth,
    history,
    isMobile
}) => {

    // Toggle Dropdown
    const [dropdown, setDropdown] = useState(false);
    const [menuHeight, setMenuHeight] = useState(null);

    const [checkFollow, setCheckFollow] = useState(false);
    const [followed, setFollowed] = useState(false);
    const [requestedFollow, setRequestedFollow] = useState(false);

    // Edit Modal toggles
    const [copied, setCopied] = useState(false);
    
    // Get the current URL and extract the "show" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const filter = url.searchParams.get("show");

    // Firebase collection ref
    const usersCollectionRef = collection(db, "users");

    // Copied Modal timer logic
    useEffect(() => {
        setTimeout(() => {
            setCopied(false);
        }, 1000);
    }, [copied]);

    // Handle logic for the Copied Modal
    const toggleCopiedModal = () => {
        setDropdown(false);
        
        // setCopiedModal(!copiedModal);
        setAlert('Copied to clipboard', 'okay');
        
    }

    // Handle logic for Reporting User
    const reportGroup = () => {
        setDropdown(false);
        
        // Show 'User Reported' Alert
        setAlert('User Reported. Thanks for letting us know.', 'okay');
    }

    // Handle redirect to group's custom url
    const handleGoToCustomUrl = async (customURL) => {
        console.log('About to Redirect to Custom URL..');

        window.open(customURL, "_blank");
    }

    // Handle follow group
    const handleFollow = async () => {

        if(auth.user) {
            if(!group) return;

            // FLAG: can't follow student only groups without a verified school email
            if(group.privacy === 'students only' && (!auth.user.school_verified || !auth.user?.school_email.trim())) {

                togglePrivacyModal('students only');
                return;
            }
            
            try {
                await followGroup(group._id, auth.user);

                if(group.privacy === 'private' && !followed) {
                    // Toggle the requested follow status
                    setRequestedFollow(!requestedFollow);
                } else {
                    // Toggle the follow status
                    setFollowed(!followed);
                }
            } catch (error) {
                console.log('Error while trying to handle follow / unfollow');
                setAlert(error.message, 'danger');
            }

        } else {

            // Toggles the authentication modal for liking
            toggleAuthModal('follow');
        }
    }

    // Checks if the user has already followed the group
    if(auth.user && group && !checkFollow) {
        if(auth.user.groups?.filter(temp_groupId => temp_groupId.toString() === group._id).length > 0){
            setFollowed(true);
        } else if(group.follow_requests?.filter(followRequest => followRequest.user._id.toString() === auth.user._id).length > 0) {
            setRequestedFollow(true);
        }
        
        // Marks that the check for likes has been performed
        setCheckFollow(true);
    }  

    // Options for a component (possibly related to a slideshow or gallery)
    const options = {
        caption: {
            showCaption: false
          },
        thumbnails: {
            showThumbnails: false
        },
        buttons: {
            showAutoplayButton: false,
            showFullscreenButton: false,
            showNextButton: false,
            showPrevButton: false,
            showThumbnailsButton: false,
        }
    }
    
    return (
        <Fragment>
            {/* SRLWrapper is a lightbox for full screen image display */}
            <SRLWrapper options={options}>
                <div className="profile__header">

                    {/* Dropdown Button */}
                    <div className='profile__moreBtns'>
                        <div onClick={() => setDropdown(!dropdown)} className="profile__moreBtn">
                            <MoreHorizIcon />
                        </div>
                    </div>

                    {/* Dropdown Menu */}
                    <div className={dropdown ? "edit-dropdown active" : "edit-dropdown"} style={{height: menuHeight}}>
                        <div className="menu">

                            {/* Copy Link to Profile option */}
                            <CopyToClipboard 
                                text={`${process.env.REACT_APP_DOMAIN}/groups/${group?._id}`}
                                onCopy={toggleCopiedModal}
                            >
                                <div className="menu-item">
                                    <LinkIcon />
                                    Copy link to group
                                </div>
                            </CopyToClipboard>

                            {/* Delete Menu Item (shown only for authenticated user who created the post) */}
                            {auth.user && group?.creator?._id === auth.user_id ? (
                                <Fragment>
                                    <div onClick={() => window.location.href = `/groups/${group._id}/edit`} className="menu-item">
                                        <EditIcon />
                                        Edit Group
                                    </div>
                                </Fragment>
                            ) : null}
                            
                            {/* Report User option */}
                            {auth.user && (
                                <div onClick={reportGroup} className="menu-item danger">
                                    {/* <OutlinedFlagTwoToneIcon /> */}
                                    Report group
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Overlay for the Dropdown */}
                    <div
                        className={`hidden-overlay ${dropdown ? "show" : ""}`}
                        onClick={() => setDropdown(!dropdown)}
                    />

                    <div style={{display: 'flex', width: '100%'}}>
                        {/* Profile Image */}
                        <div className="profile__image small">
                            <a href={group && group.avatar}>
                                {group && group.avatar ? (
                                    <Avatar src={group.avatar} />
                                ) : (
                                    <DefaultAvatar name={`${group.name}`} />
                                )}
                            </a>
                        </div>
                        
                        <div style={{padding: '5px 16px'}}>
                            {/* Profile User Name */}
                            <div className="profile__headerBody">
                                <h2>
                                    {group.name}
                                </h2>
                            </div>

                            {/* Profile Stats */}
                            {/* <div className="profile__stats">
                                <p><span className="profile__specialStat">451</span> Bought</p>
                                <p><span className="profile__specialStat">329</span> Sold</p>
                                <p><span className="profile__specialStat">1,015</span> Likes</p>
                            </div> */}
                            
                            <div className="profile__membership">
                                {group.privacy === 'public' && (
                                    <Fragment>
                                        <PublicIcon />
                                        <p style={{marginRight: '5px'}}>Public group</p>
                                    </Fragment>
                                )}
                                {group.privacy === 'restricted' && (
                                    <Fragment>
                                        <VisibilityIcon />
                                        <p style={{marginRight: '5px'}}>Restricted group</p>
                                    </Fragment>
                                )}
                                {group.privacy === 'private' && (
                                    <Fragment>
                                        <LockIcon />
                                        <p style={{marginRight: '5px'}}>Private group</p>
                                    </Fragment>
                                )}
                                {group.privacy === 'students only' && (
                                    <Fragment>
                                        <SchoolIcon />
                                        <p style={{marginRight: '5px'}}>Students only</p>
                                    </Fragment>
                                )}

                                <b>{group.follower_count || '--'} members</b>
                            </div>
                            
                            {group.url?.trim() ? (
                                <Fragment>
                                    <Button 
                                        onClick={() => handleGoToCustomUrl(group.url)}
                                        variant="outlined" 
                                        className={`sidebar__tweet black minWidth`}
                                        style={{marginRight: '10px'}}
                                    >
                                        <div className='icon_20' style={{display: 'flex', alignItems: 'center'}}>
                                            <LinkIcon />
                                        </div>
                                        <span style={{width: '5px'}}></span>
                                        Visit Website
                                    </Button>
                                </Fragment>
                            ) : (
                                <Fragment>
                                    {(group.creator?._id !== auth?.user?._id) && (
                                        <Button 
                                            onClick={handleFollow}
                                            variant="outlined" 
                                            className={`sidebar__tweet ${followed ? '' : requestedFollow ? 'grey' : 'black'} minWidth`}
                                            style={{marginRight: '10px'}}
                                        >
                                            {/* Icon */}
                                            {auth.user && (
                                                <div className='icon_20' style={{display: 'flex', alignItems: 'center'}}>
                                                    {(!followed && !requestedFollow) && <AddIcon />}
                                                </div>
                                            )}
                                            <span style={{width: '5px'}}></span>
                                            {auth.user ? followed ? 'Unfollow' : requestedFollow ? 'Requested' : 'Follow' : 'Join group'}  
                                        </Button>
                                    )}
                                </Fragment>
                            )}

                        </div>
                    </div>

                    {/* Profile Header Tabs */}
                    <div className="profile__headerTabs">
        
                        <a href={`/groups/${group?._id}`}>
                            <div className={`${(filter === null || filter === undefined || filter === 'about') && 'active'}`}>
                                <h3>About</h3>
                                <div className="block__underline"></div>
                            </div>
                        </a>

                        <a href={`/groups/${group?._id}?show=posts`}>
                            <div className={`${(filter && filter === 'posts') && 'active'}`}>
                                <h3>Posts</h3>
                                <div className="block__underline"></div>
                            </div>
                        </a>

                        <a href={`/groups/${group?._id}?show=photos`}>
                            <div className={`${(filter && filter === 'photos') && 'active'}`}>
                                <h3>Photos</h3>
                                <div className="block__underline"></div>
                            </div>
                        </a>
                    </div>
                </div>
            </SRLWrapper>
        </Fragment>
    )
}

GroupHeader.propTypes = {
    // Prop type validation for authentication
    auth: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    group: PropTypes.object.isRequired,
    // Prop type validation for function to toggle the profile modal
    toggleProfileModal: PropTypes.func.isRequired,
    // Prop type validation for function to toggle the auth modal
    toggleAuthModal: PropTypes.func.isRequired,
    togglePrivacyModal: PropTypes.func.isRequired,
    // Prop type validation for function to set alerts
    setAlert: PropTypes.func.isRequired,
    followGroup: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the authentication state
    auth: state.auth,
    nav: state.nav,
    group: state.group
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setAlert,
    followGroup,
    toggleProfileModal, 
    toggleAuthModal,
    togglePrivacyModal
})(GroupHeader);
